import React from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import { faDropbox } from "@fortawesome/free-brands-svg-icons";
import SearchRow from "./SearchRow";

export default function ShipTable({
  headers,
  data,
  loading,
  lang,
  indexOfFirstData,
  dataCheckbox,
  onToggleCheck,
  onSearchChange,
  onOpenDetail,
  onOpenEdit,
  onOpenShip,
}) {
  return (
    <div className="table-responsive table-custom design-table _table-custom">
      <table bordered="true" className="align-center">
        <thead>
          <tr>
            <td></td>
            <td>#</td>
            {headers.map((h) => (
              <td key={h.label}>{h.label}</td>
            ))}
            <td style={{ position: "sticky", right: "-1px", zIndex: 1 }}>
              Thao Tác
            </td>
          </tr>
        </thead>

        <tbody>
          <SearchRow onChange={onSearchChange} />

          {loading ? (
            <tr>
              <td colSpan={99} style={{ textAlign: "center" }}>
                <img width={40} src="/images/icon/load.gif" alt="Loading..." />
              </td>
            </tr>
          ) : data?.length ? (
            data.map((item, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="checkbox"
                    className="form-control pointer"
                    checked={dataCheckbox.find(
                      ({ phieuxuatkhosaas }) =>
                        phieuxuatkhosaas === item?.phieuxuatkhosaas
                    )}
                    onChange={(e) => onToggleCheck?.(e.target.checked, item)}
                  />
                </td>
                <td>{indexOfFirstData + index + 1}</td>

                {headers.map(
                  ({ displayFields, isDate = false }, headerIndex) => {
                    const raw = item?.[displayFields];
                    const value = isDate
                      ? raw && moment(raw, moment.ISO_8601, true).isValid()
                        ? moment(raw).utc().format("DD/MM/YYYY HH:mm:ss")
                        : ""
                      : raw;
                    return (
                      <td key={headerIndex}>
                        {Array.isArray(displayFields)
                          ? displayFields.map((f) => [item?.[f]]).join("\n")
                          : Array.isArray(value)
                          ? value.join("\n")
                          : value}
                      </td>
                    );
                  }
                )}

                <td
                  style={{
                    position: "sticky",
                    right: "-1px",
                    zIndex: 1,
                    background: "white",
                  }}
                >
                  <button
                    className="btn btn-primary mr-2"
                    onClick={() => onOpenDetail?.(item)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                  <button
                    className="btn btn-warning mr-2"
                    data-toggle="modal"
                    data-target="#EditModal"
                    onClick={() => onOpenEdit?.(item)}
                  >
                    <FontAwesomeIcon icon={faDropbox} />
                  </button>
                  <button
                    className="btn btn-primary"
                    data-toggle="modal"
                    data-target="#ShipModal"
                    onClick={() => onOpenShip?.(item)}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                className="align-center font-weight-bold"
                colSpan={headers.length + 10}
              >
                {lang["not found"]}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
